/**
 * FR-4.1 names these eleven as a minimum, in this order.
 *
 * "Other" sits last because it is where things go when none of the others fit,
 * and a list that ended somewhere else would read as though it were still
 * enumerating kinds of thing.
 */
export const DEFAULT_CATEGORIES = [
    { id: '0199ca00-0001-7000-8000-000000000001', name: 'Clothing' },
    { id: '0199ca00-0001-7000-8000-000000000002', name: 'Footwear' },
    { id: '0199ca00-0001-7000-8000-000000000003', name: 'Electronics' },
    { id: '0199ca00-0001-7000-8000-000000000004', name: 'Furniture' },
    { id: '0199ca00-0001-7000-8000-000000000005', name: 'Kitchen' },
    { id: '0199ca00-0001-7000-8000-000000000006', name: 'Books and media' },
    { id: '0199ca00-0001-7000-8000-000000000007', name: 'Tools' },
    { id: '0199ca00-0001-7000-8000-000000000008', name: 'Sporting goods' },
    { id: '0199ca00-0001-7000-8000-000000000009', name: 'Documents' },
    { id: '0199ca00-0001-7000-8000-00000000000a', name: 'Sentimental' },
    { id: '0199ca00-0001-7000-8000-00000000000b', name: 'Other' },
];
/**
 * The defaults this account has never had.
 *
 * Presence, not liveness. A category the user deleted is still in the manifest
 * carrying its tombstone, so it is not missing and is not recreated -- which is
 * the whole difficulty with seeding defaults into data the user owns. Offering
 * them once is helpful; restoring them every time the app opens would be the
 * app overruling a decision the user already made.
 *
 * A renamed category is likewise present, so a reseed cannot rename it back.
 */
export function missingDefaultCategories(categories) {
    return DEFAULT_CATEGORIES.filter((category) => !categories.has(category.id));
}
/** Whether this account has seen the defaults at all, which is the first-run test. */
export const hasAnyDefaultCategory = (categories) => DEFAULT_CATEGORIES.some((category) => categories.has(category.id));
//# sourceMappingURL=defaults.js.map